import { getEnvironment } from "@/lib/env/getEnvironment"

export const reportError = (
  error: unknown,
  context?: Record<string, unknown>,
): void => {
  const env = getEnvironment()
  const err = error instanceof Error ? error : new Error(String(error))
  const isClient = typeof window !== "undefined"

  // Logging + RUM matrix:
  //   dev           → console only (no RUM — init is gated out)
  //   staging       → console only (RUM is browser-only; server has no addError)
  //   prod-server   → console (dd-trace logInjection correlates the log to the APM span)
  //                   + tag the active APM span so error message/stack appear in traces
  //   prod-browser  → RUM addError only (no console to avoid double-logging)
  if (env !== "production" || !isClient) {
    console.error(err, context)
  }
  if (env === "development") return

  if (!isClient) {
    // Server: tag the active dd-trace span with the error so APM traces show the
    // message and stack instead of "Missing error message and stack trace".
    // Dynamic import keeps dd-trace out of the client bundle.
    void import("dd-trace").then((tracer) => {
      const span = tracer.default.scope().active()
      if (!span) return
      span.setTag("error", err)
      if (context) {
        span.setTag("error.context", JSON.stringify(context))
      }
    })
    return
  }

  // Browser: RUM Error Tracking. Dynamic import keeps @datadog/browser-rum out
  // of the server bundle. The module is already in the client bundle so the
  // import resolves synchronously from the module cache.
  void import("@datadog/browser-rum").then(({ datadogRum }) => {
    datadogRum.addError(err, context)
  })
}
